import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import HamburgerMenu from './HamburgerMenu';
import Tooltip from './Tooltip';
import './Header.css';

const ROUTE_TITLES = {
  '/': null,
  '/dictionary': 'Dictionary',
  '/dictionary/legacy': 'Legacy dictionary',
  '/annotate': 'Annotate',
  '/settings': 'Settings',
  '/about': 'About',
};

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const pageName = ROUTE_TITLES[location.pathname] ?? null;

  return (
    <>
      <header className="header">
        <div className="header-inner">
          <div className="header-brand">
            <Link to="/" className="header-logo">hoja</Link>
            {pageName && (
              <span className="header-page-name" aria-current="page"> | {pageName}</span>
            )}
          </div>
          <Tooltip label="Open menu">
            <button
              className="header-menu-btn"
              onClick={() => setMenuOpen(true)}
              aria-label="Open menu"
            >
              ☰
            </button>
          </Tooltip>
        </div>
      </header>

      {menuOpen && (
        <HamburgerMenu onClose={() => setMenuOpen(false)} />
      )}
    </>
  );
}

export default Header;
